/**
 * Survey: PROJECT - FINAL
 * Question: How has your career status changed after the program?
 * 
 * == final
 * career_status_biz_t1
 * 
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursThatHadScaledUpTheirBusinessTotalCalculation = (props: any) => {
    const scaledBusiness = props.finalSubmissions.filter((submission: any) => submission.career_status_biz_t1 === 'BIZ_SCALE_T1')

    return (scaledBusiness.length / props.finalSubmissions.length * 100).toFixed(2);
}